module.exports = __webpack_public_path__ + "static/media/packMesure.6b3ff33a.png";